/**
 * Identidad de marca Yulqo (plataforma).
 * Los comercios Pro pueden sobrescribir primary/secondary en branding.
 */
export type PlatformBrand = {
  productName: string;
  productShortName: string;
  businessName: string;
  queueName: string;
  scanName: string;
  notifyName: string;
  insightsName: string;
  tagline: string;
  subtitle: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  highlightColor: string;
  nightColor: string;
  backgroundColor: string;
  surfaceColor: string;
  textPrimary: string;
  textSecondary: string;
  terraDark: string;
};

export const PLATFORM_BRAND: PlatformBrand = {
  productName: "Yulqo",
  productShortName: "Yulqo",
  businessName: "Yulqo Business",
  queueName: "Yulqo Queue",
  scanName: "Yulqo Scan",
  notifyName: "Yulqo Notify",
  insightsName: "Yulqo Insights",
  tagline: "Sin fila. Solo tu turno.",
  subtitle:
    "Yulqo ayuda a negocios a gestionar esperas con QR y avisa a cada cliente antes de su turno, sin que nadie tenga que hacer cola en la calle.",
  primaryColor: "#D9774B",
  secondaryColor: "#8FA58A",
  accentColor: "#8FA58A",
  highlightColor: "#F4C95D",
  nightColor: "#3B2A20",
  backgroundColor: "#FBF4EA",
  surfaceColor: "#FFF8EE",
  textPrimary: "#3B2A20",
  textSecondary: "#6B5446",
  terraDark: "#B85E35",
};

export const FACE_COLORS = [
  "#D9774B",
  "#8FA58A",
  "#F4C95D",
  "#EFB9A3",
  "#B98B6E",
  "#A9C1D9",
] as const;
